module.exports = __webpack_public_path__ + "img/icon-whatsapp.ec686f15.svg";